var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos18ToolbrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.736842,
    y: 0.736842,
    width: 12.5263,
    height: 6.63158,
    rx: 1.47368,
    stroke: "#00322E",
    strokeWidth: 1.47368
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.736847 10.3157H13.2632",
    stroke: "#00322E",
    strokeWidth: 1.47368,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.736847 13.2632H8.84211",
    stroke: "#00322E",
    strokeWidth: 1.47368,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos18ToolbrIcon);
export default __webpack_public_path__ + "static/media/ios-18-toolbr-icon.a8c1f5f3bbcf0910dfc387db05931263.svg";
export { ForwardRef as ReactComponent };